export const stakeSelectRippleOptions = {
  centered: true,
  disabled: false,
  unbounded: false,
  radius: 35,
  color: 'primary',
};

export const gameSelectRippleOptions = {
  centered: true,
  disabled: false,
  unbounded: false,
  radius: 35,
  color: 'primary',
};

export const operatorsRippleOptions = {
  centered: true,
  disabled: false,
  unbounded: false,
  radius: 35,
  color: 'primary',
};

export const submitBtnRippleOptions = {
  centered: true,
  disabled: false,
  unbounded: false,
  radius: 50,
  color: 'primary',
};

export const horseSelectRippleOptions = {
  centered: true,
  disabled: false,
  unbounded: false,
  radius: 50,
  color: 'primary',
};

export const reunionSelectRippleOptions = {
  centered: false,
  disabled: false,
  unbounded: false,
  radius: 35,
  color: 'primary',
};

export const raceSelectRippleOptions = {
  centered: false,
  disabled: false,
  unbounded: false,
  radius: 35,
  color: 'primary',
};

export const gameInfoSelectRippleOptions = {
    centered: true,
    disabled: false,
    unbounded: false,
    radius: 25,
    color: 'primary',
  };
